import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useApi } from '../../hooks/useApi';
import { ForumPost, ApiForumPost } from '../../models/ForumPost';
import { toast } from 'react-toastify';
import Spinner from '../../components/Spinner';
import ForumForm from './ForumForm';

const ForumEdit = () => {
  const { id } = useParams<{ id: string }>();
  const [ initialValues, setInitialValues ] = useState<object | null>(null);
  const { get, post, loading } = useApi();
  const navigate = useNavigate();

  useEffect(() => {
    get({
      endpoint: `api/v1/forum_posts/${ id }`,
      onSuccess: (res) => {
        const p = new ForumPost(res.data as ApiForumPost);
        setInitialValues({
          area: p.area || '',
          bloodType: p.bloodType || [],
          ageRange: p.ageRange || [],
          bodyFigure: p.bodyFigure || [],
          heightRange: p.heightRange || [],
          description: p.description || '',
          expiresAt: p.expiresAt ? p.expiresAt.slice(0, 10) : '',
        });
      },
      onError: () => { toast.error('投稿の取得に失敗しました'); },
    });
  }, [ get, id ]);

  const handleSubmit = (body: Record<string, string | string[] | undefined | null>, status: 'DRAFT' | 'OPEN') => {
    post({
      endpoint: `api/v1/forum_posts/${ id }`,
      method: 'PATCH',
      body: { ...body, status },
      onSuccess: () => {
        toast.success(status === 'DRAFT' ? '下書きを保存しました' : '投稿しました');
        navigate('/mypage/forum');
      },
      onError: (err) => { toast.error(err?.data?.message || '保存に失敗しました'); },
    });
  };

  if (!initialValues) return <Spinner centered={ true } color="pink" />;

  return (
    <ForumForm
      title="募集投稿を編集"
      initialValues={ initialValues }
      loading={ loading }
      onSubmit={ handleSubmit }
    />
  );
};

export default ForumEdit;
